import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { DataService } from './data.service';
import { DatePipe, Location } from '@angular/common';
import { Router } from '@angular/router';
import { RouteConstants } from 'src/assets/constants/route';
import { ToasterService } from './toaster.service';
import { EmpStatus, EmployeeDesignation, RelationsData, SnackbarData, TenureDetails, TosterMsgType } from './model';
import { FetcherService } from './fetcher.service';
import { DialogBoxService } from './dialog-box.service';
import { CleverTapConstents, ConstantData, LoanStatusConstant } from './constants';
import { LoaderService } from './loader.service';
import { Subject, Subscription } from 'rxjs';
import { PermissionsService } from './permission.dialog.service';

import { Callbacks } from 'jquery';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  userLoggedInEventCalled: Subject<boolean> = new Subject();
  updatedDataInstitue: Subject<boolean> = new Subject();
  // variable to store the setInterval for the token
  private tokenExpirationIntervale: any;
  // variable to store the setInterval for the refresh token
  private refreshTokenExpirationIntervale: any;

  // getter to identify if user is logged in for not.
  get isUserLoggedIn(): boolean {
    return +(localStorage.getItem('expires_in') || 0) > 0;
  }

  get isMobile(): boolean {
    return window.innerWidth < 767 ? true : false;
  }

  get showFooter(): boolean {
    return (this.router.url == RouteConstants.routes.footer) ? true : false;
  }

  get isProduction(): boolean {
    return this.api.isProduction;
  }

  get customerTestimonials(): any {
    return this.dataservice.customerTestimonials;
  }

  get stats(): any {
    return this.getCache('stats');
  }

  // redirect url
  // redirectUrl: string = 'http://localhost:4200'
  get redirectionUrl(): string {
    if (window.location.host.includes('localhost')) {
      return 'http://localhost:4200/';
    }
    return this.api.redirectionUrl || ('https://' + window.location.hostname + (window.location.port ? ':8443' : '') + '/pbl-customer-portal/');
  }

  get loanDetails() {
    const loanData = { ...this.dataservice.loanDetails };
    loanData.isMajor = loanData.institutionInfo != null && loanData.institutionInfo!.dob != null && this.getIsAdult(loanData.institutionInfo!.dob!);
    loanData.isStudentMainApplicant = loanData.isMajor && (loanData.isEmployed || loanData.isSelfEmployed || loanData.hasMoratorium || loanData.isCapacitaFlow);
    loanData.isSponser = loanData?.productCategoryId != 'EL_SF' && loanData?.institutionInfo?.repayer == 0 && this.getCurrentApplicant.mainApplicant == true && this.getIsAdult(loanData!.institutionInfo!.dob!) && !loanData!.isCapacitaFlow && !loanData!.hasMoratorium && loanData!.institutionInfo.employmentStatus !== '3';
    loanData.isStudentMajorandHclorCap = (loanData.hasMoratorium
      || loanData.isCapacitaFlow)
      && loanData.isMajor;
    loanData.isMaOlderThen55 = () => (loanData.institutionInfo?.dob != null ? this.getIsAdult(loanData.institutionInfo!.dob!, ConstantData.inuranceAgelimit) : false);
    loanData.partialApproved = loanData.loanCommercialDetails?.length > 0 ? loanData.loanCommercialDetails![0].tenor != loanData.institutionInfo!.tenorMonths : false;
    loanData.partialApprovedAmount = loanData.loanCommercialDetails?.length > 0 ? loanData.loanCommercialDetails![0].amount != loanData.institutionInfo!.amount : false;
    loanData.isInsuranceAdditionNotCompleted = loanData.insuranceConfirmation != true && loanData.kfsDocumentConfirmation != true;
    loanData.isKfsNotComplete = loanData.amount != null && loanData.kfsDocumentConfirmation != true;
    loanData.isAfNotComplete = loanData.applicationFormConfirmation != true;
    loanData.isPfNotComplete = loanData.processingFee != 0 && loanData.pfConfirmation != true;
    loanData.isPNACHNotComplete = !loanData.loanAttachment?.find((element: any) => element.docType == 'PNACH_FORM');
    loanData.isAllSigned = () => {
      let status = true;
      if (loanData.eSignStatusModel == null) return false;
      let i: any;
      for (i in loanData.eSignStatusModel!.signerDetails!) {
        if (i.signed == false) {
          status = false;
          break;
        }
      }
      return status;
    }
    loanData.loanApplicantDetails = loanData.loanApplicantDetails?.map((applicant: any) => {
      return {
        ...applicant,
        bankPending: applicant.bankConfirmation != true,
        selfiNotComplete: !applicant.loanAttachment?.find((element: any) => element.docType == 'SELFIE')
      };
    })
    loanData.isWaitingForSanction = (loanData.statusId == LoanStatusConstant.inProgress ||
      loanData.statusId == LoanStatusConstant.submittedForSanction) &&
      loanData.reviewedAndSubmitted == true;

    return this.dataservice.loanDetails ? loanData : undefined;
  }
  formator = new Intl.NumberFormat('en-IN',);
  get getCurrentApplicant() {
    const cuApp = this.dataservice.getCurrentApplicant;
    return { ...cuApp, isSalaried: cuApp?.empInfo?.designationTypeId == 1, isSelfEmployed: cuApp?.empInfo?.designationTypeId == 3, isUnEmployed: cuApp?.empInfo == null || cuApp?.empInfo?.designationTypeId == 4 };
  }
  get empStatus(): EmpStatus[] {
    return this.dataservice.empStatus;
  }
  get employeeDesignation(): EmployeeDesignation[] {
    return this.dataservice.employeeDesignation;
  }
  get waitingResponse() {
    return this.dataservice.waitingResponse;
  }

  get relations(): RelationsData[] {
    return this.dataservice.relations;
  }

  get config() {
    return this.dataservice.config;
  }
  get loaderService() {
    return this.loaderS;
  }

  get rmDetails() {
    return this.dataservice.rmDetails;
  }
  userId: any;


  constructor(public permissionsService: PermissionsService, private loaderS: LoaderService, private api: ApiService, private dataservice: DataService, private location: Location, private toasterService: ToasterService, private router: Router, private fetchservice: FetcherService, private dialogBox: DialogBoxService) { }

  /**
  method to make api calls
  @param type - post/get/delete/put
  @param url - api url that needs to be trigger
  @param body - Object that need to be pass in request
  @param applicationType - Content-Type
  @param nonJsonResponse - boolean value - true when response going to be string/boolean/number, false when reponse going to be Object/Array
  @param handleError - boolean value - true when want to handle the error and false when don't want to handle the error if any
  */
  handleRequests(type: string, url: string, body?: any, applicationType?: any, nonJsonResponse?: any, handleError?: boolean, showLoader: boolean = true, isRawUrl: boolean = false): Promise<any> {
    return this.api.handleRequest(type, url, body, applicationType, nonJsonResponse, handleError, showLoader, isRawUrl).catch((err) => {
      if (err.status === 401) {
        this.logout();
      }
      throw err;
    });
  }


  /**
  * method used to access the value of the cache variable by passing the key as target.
  * @param target : string - will be the key of the cache object.
  * @returns value of the respective key of the cache object.
  */
  getCache(target: string) {
    if (target === 'ishome') {
      const main = sessionStorage.getItem('route');
      return main === 'home' || main === 'main';
    }
    return this.dataservice.getCache(target);
  }

  /**
  * method used to clear the values of the cache variable.
  */
  clearCache() {
    this.dataservice.clearCache();

  }

  /**
  * method used to set the value of the cache variable by passing the key as target.
  * @param target : string - will be the key of the cache object.
  * @param value : type can be anything - value that you want to set a
  * @returns value of the respective key of the cache object.
  */
  setCache(target: string, value: any) {
    return this.dataservice.setCache(target, value);
  }


  /**
   * method used to get the api url
   * @param target - string -
   * @param params - array or null - param/query param array that you need to pass in the url.
   * @returns string - api url
   */
  getUrl(target: string, params?: any[]): string {

    return this.api.getUrl(target, params);

  }


  /**
   * Mehtod to fetch the b2c login url and redirect user to the b2c login web page
   * @param phoneNumber - 10-digit valid phone number
   */
  login(phoneNumber: any) {
    this.handleRequests('get', this.getUrl('token_loginUrl')).then((res: any) => {
      const loginUrl = res.content + '&phoneNumber=' + phoneNumber + '&ep=do_send_code';
      window.location.assign(loginUrl.replace('http://localhost:4200', this.redirectionUrl));

      this.cleverTapEventCall(CleverTapConstents.registration_Initiated);
      // window.location.assign(loginUrl.replace('https://jwt.ms/', "http://localhost:4200/"));
    });

  }

  /**
  * Mehtod to fetch the b2c email verification url and redirect user to the b2c email verification web page
  * @param email - string - valid email id
  */
  emailVerification(email?: string) {
    return this.handleRequests('post', this.getUrl('user_email_generateOtp'), {
      "email": email,
    }).then((res: any) => {
      if (res.status === 'SUCCESS') {
        return res.status;
      } else {
        this.showToaster('Something went wrong', TosterMsgType.ERROR);
      }


    });
  }


  addEmailId(obj: any) {
    if (obj.status === 'SUCCESS') {
      this.handleRequests('put', this.getUrl('user_addEmail'), { email: obj.EV }).then((res: any) => {
        this.getToken('');
      }).catch(() => {
        this.getToken('');
      });

    } else {
      this.showToaster('Email Verification failed!! Please try again!', TosterMsgType.ERROR);
      this.getToken('');
    }
  }


  /**
   * method to refresh & fetch the access token
   * @param code - token code recived from the b2c login in the query params
   */
  getToken(code: string, isRefresh: boolean = false, showError: boolean = true, outputs: string = '', callBack: any = null) {
    let isRefreshToken: boolean = false;
    if (localStorage.getItem('refresh_token')) {
      isRefreshToken = true;
    }
    let output = '';
    if (outputs) {
      output = outputs;
      localStorage.setItem('paymentOutput', output);
    } else {
      output = localStorage.getItem('paymentOutput') || '';
    }
    if (!isRefreshToken && !code) {
      setTimeout(() => {
        this.userLoggedInEventCalled.next(false);
      }, 3000);
      this.logout();
      return;
    }
    this.handleRequests('post', this.getUrl(isRefreshToken ? 'token_refreshUrl' : 'token_loginUrl'), { tokenCode: isRefreshToken ? localStorage.getItem('refresh_token') : code, redirectUri: 'string' }, null, null, showError).then((res: any) => {
      localStorage.setItem('access_token', res.access_token);
      localStorage.setItem('expires_in', res.expires_in);
      localStorage.setItem('refresh_token', res.refresh_token);
      localStorage.setItem('refresh_token_expires_in', res.refresh_token_expires_in);
      this.getUserInfo(output, isRefresh);


      if (this.tokenExpirationIntervale) {
        clearInterval(this.tokenExpirationIntervale);
      }

      if (res.expires_in) {
        this.tokenExpirationIntervale = setInterval(() => {
          let expires_in = + (localStorage.getItem('expires_in') || 0);
          if (expires_in >= 1000) {
            localStorage.setItem('expires_in', (expires_in - 1).toString());
          } else {
            clearInterval(this.tokenExpirationIntervale);
            if (this.getCache('userLogin')) {
              this.getToken('', true);
            } else {
              this.logout();
            }
          }
        }, 1000);
      }

      if (this.refreshTokenExpirationIntervale) {
        clearInterval(this.refreshTokenExpirationIntervale);
      }

      if (res.refresh_token_expires_in) {
        this.refreshTokenExpirationIntervale = setInterval(() => {
          let expires_in = + (localStorage.getItem('refresh_token_expires_in') || 0);
          if (expires_in >= 1000) {
            localStorage.setItem('refresh_token_expires_in', (expires_in - 1).toString());
          } else {
            clearInterval(this.refreshTokenExpirationIntervale);
            this.logout()
          }
        }, 1000);
      }


      // !isRefresh &&
      //  this.route('home');
      //  this.getLoandetails().then(()=>this.navigationHandler());

    },).catch((err) => {
      this.userLoggedInEventCalled.next(false);
      this.logout();

    });
  }


  getUserInfo(output: string = '', isRefresh: boolean = false, callback?: any) {
    return this.handleRequests('get', this.getUrl('user_current')).then(async (res: any) => {
      this.setCache("userInfo", { userInfo: res.content });
      this.userId = res.content.id;
      this.cleverTapEventCall('onUserLogin', {
        Site: {
          Identity: res.content.id,
        },
      });
      if (!res?.content?.email) {
        this.route('emailVerification');
      }
      await this.handleRequests('get', this.getUrl('constants_all')).then(res => {
        this.setCache("allConstant", res);

      });
      await this.loadConstantData();
      this.getProducts().then(() => {
        this.loaderS.show();
        setTimeout(() => {

          const ishomeRoute: boolean = sessionStorage.getItem('ishomeRoute') === 'true';
          !isRefresh && (ishomeRoute ? this.route(sessionStorage.getItem('route')) : this.navigationHandler());
          this.userLoggedInEventCalled.next(true);
          callback && callback();
          if (localStorage.getItem('cat') && localStorage.getItem('lat') && !localStorage.getItem('currentInstituteCourses')) {
            this.route('institutes');
          }
          this.loaderS.hide();
        }, 1000)
        if (output) {
          this.notifyPayment(output);
        }
      });

    }).catch((err) => {
      this.logout();
    });
  }

  loadConstantData(isLoading: boolean = true) {
    return this.handleRequests('get', this.getUrl('constants_all_landing'), undefined, undefined, undefined, undefined, isLoading).then(res => {
      this.setCache("allConstantLanding", res);
      this.handleRequests('get', this.getUrl('product_stats'), undefined, undefined, undefined, undefined, isLoading).then((stats: any) => {

        this.setCache("stats", stats);
      });
    });
  }

  /**
   * Method to clear the localstorage and redirect the user to home page
   */
  logout() {
    if (localStorage.getItem('access_token')) {
      this.handleRequests('post', this.getUrl('user_logout')).then(() => { });
    }
    this.userId = null;
    localStorage.clear();
    sessionStorage.clear();
    this.clearCache();
    this.setCache('ishome', true);
    this.getProducts('product_configInfo_landingScreen');
    this.route('main');

  }

  /* For POpuo Dialog */
  popupVisible: boolean = false;
  showDialog() {
    this.popupVisible = true;
  }

  route(target: any, parameters?: any, isfinal: boolean = false) {
    let routes: any = RouteConstants.routes;
    if (routes[target] === routes.eligibility) {
      this.dialogBox.showEligibilityDialog();
      return;
    }
    sessionStorage.setItem('route', target);
    if (routes.hasOwnProperty(target)) {
      this.router.navigate([routes[target]], { queryParams: parameters })
        .finally(() => {
          if (!isfinal) {
            setTimeout(() => {
              if (target === 'studentDetails')
                this.getLoandetails().then(() => this.route(target, parameters, true));
              else
                this.route(target, parameters, true)
            });
          }
          document.querySelector('.landing-content')?.scroll(0, 0);

          window.history.pushState({}, 'locationState', this.isProduction ? `/` : `/pbl-customer-portal/`);
          setTimeout(() => {
            !this.loaderService.isLoader && (<any>document.querySelector('input:not(:disabled):not([readonly])[type="text"],input:not(:disabled):not([readonly])[type="dd"]'))?.focus();
            if (this.loaderService.isLoader) {
              const sub: Subscription = this.loaderService.loaderState.subscribe((v) => {
                !v && (<any>document.querySelector('input:not(:disabled):not([readonly])[type="text"],input:not(:disabled):not([readonly])[type="dd"]'))?.focus();
                sub.unsubscribe();
              })
            }
          }, 500);
        });

    }

  }

  /**
   * Method to show the toast message
   * @param msg - string - Message the you want to show
   * @param type - TosterMsgType - enum that can have ERROR/SUCCESS/WARNING type.
   * @param timer - number - time in miliseconds
   */
  showToaster(msg: string, type: TosterMsgType, timer?: number, callBack?: any, isTimer: boolean = true) {
    this.toasterService.showMsg(msg, type, timer, callBack, isTimer);
  }

  getUserName() {
    return this.getCache('userInfo')?.userInfo.email?.split('@')[0] ?? 'Welcome';
  }

  /**
   * Method to fetch the product detail
   * @param target - string - Api target string based on which we will fetch the api url and hit an api to get the details
   * @returns - Promise - Which will have the loan details api reponse.
   */
  getProducts(target: string = 'product_configInfo', showLoader: boolean = true): Promise<any> {
    this.loadConstantData(showLoader);
    return this.handleRequests('get', this.getUrl(target), undefined, undefined, undefined, undefined, showLoader).then(async (res: any) => {
      this.setCache('products', res);
      if (target == 'product_configInfo')
        return this.getLoandetails(showLoader);

    })
  }

  /**
   * Method to convert the base64 string to base64 image url
   * @param imageString - base64 string
   * @returns base64 image url
   */
  getImageFromBase64(imageString: string) {
    return 'data:image/png;base64,' + imageString;
  }


  // Method to get the loan detail
  getLoandetails(showLoader: boolean = true) {
    return this.fetchservice.getLoanDetails(showLoader).then((res: any) => {
      return res;
    });;
  }



  /**
   * Function to handle the navigations based on the current loan details
   */
  navigationHandler(isSnackBar?: boolean) {
    // if(localStorage.getItem ('isInstitutePgae')){
    //   return this.route('institutes');
    // }
    const lsm = this.loanDetails;
    let snackbar: SnackbarData | null = null;
    // if (!isSnackBar)
    // console.log(lsm);

    if (lsm) {
      snackbar = { message: '', navigation: () => { }, isRepeat: false };
      switch (true) {

        case lsm.isInRejectedState:
          snackbar.message = 'Please start over';
          snackbar.navigation = lsm.isPfNotComplete ? () => {
            this.route('home');
            this.show(
              ConstantData.rejectionText1,
              this.discardLoan.bind(this, this.route.bind(this, 'home')),
              () => { }, false, true, '',
              '',
              '',
              ConstantData.rejectionText3,
              ConstantData.rejectionBtnText,
              false, true,
              ConstantData.warnImage
            );
          } :
            this.route.bind(this, 'eligibility');
          break;

        //fund disbursed
        case lsm.statusId == LoanStatusConstant.active:
          snackbar.message = 'Fund disbursed';
          snackbar.navigation = () => {
            this.route('home');
            this.show('', '', this.route.bind('home'), false, false, '', '', '', '', '', true);
          };
          break;

        // School fee
        case lsm.isSFLoan:
          this.navigationForSF(lsm, snackbar);
          break;

        // course not selected
        case lsm.isCourceNotSelected:
          snackbar.message = 'Course not selected';
          snackbar.navigation = this.showToaster.bind(this, 'course not selected', TosterMsgType.SUCCESS);
          break;

        // add course details
        case !lsm.institutionInfo?.courseId:
          snackbar.message = 'Add course details';
          snackbar.navigation = this.showToaster.bind(this, 'add course details', TosterMsgType.SUCCESS);
          break;

        // add loan details
        case lsm.isAdditionalInfoNotAdded:

          switch (true) {
            // add student details
            case lsm.institutionInfo?.tenorMonths != null:
              snackbar.message = 'Add student details';
              snackbar.navigation = this.route.bind(this, 'studentDetails');
              break;
            // add loan details
            default:
              snackbar.message = 'Add loan details';
              snackbar.navigation = this.route.bind(this, 'loanDetails');
              break;
          }
          break;

        case lsm.notSubmitedForReview:

          switch (true) {
            //add pan detail
            case lsm.isMaPanNotComplete:
              snackbar.message = 'Add basic details';
              snackbar.navigation = this.route.bind(this, 'basicDetails');

              break;

            case lsm.hasCoapplicant:
              this.navigationForcoApplicant(lsm, snackbar);
              break;
            case (lsm.hasMoratorium || lsm.isCapacitaFlow) && lsm.isStudentMainApplicant:
              this.navigationForMoratorium(lsm, snackbar);
              break;
            case lsm.empDetailsNotAdded:
              snackbar.message = 'Add Employement details';
              snackbar.navigation = this.route.bind(this, 'employmentDetails');
              break;

            case lsm.amount == null && !lsm.isStudentMajorandHclorCap:
              this.bankScreenLogic(snackbar, lsm);
              break;

            case lsm.isInsuranceAdditionNotCompleted && !lsm.isStudentMajorandHclorCap:
              snackbar.message = 'Add Insurance details';
              snackbar.navigation = this.route.bind(this, 'insurance');
              break;

            case ((lsm.isStudentMainApplicant && (lsm.isEmployed || lsm.isSelfEmployed)) ||
              !lsm.isStudentMainApplicant) &&
              lsm.isMaBankNotComplete && !lsm.isStudentMajorandHclorCap:
              this.bankDetailsSnackbar(snackbar, lsm);
              break;

            case lsm.isMaAadharNotComplete:
              snackbar.message = 'Add your Aadhaar details';
              snackbar.navigation = this.route.bind(this, 'aadharDetails');
              break;
            case lsm.isMaSelfiNotComplete || lsm.notSubmitedForReview:
              snackbar.message = 'Upload your selfie';
              snackbar.navigation = this.route.bind(this, 'selfie');
              break;

            //////this default scenario will never come///////

            // default:
            //   snackbar.message = 'Navigation not handled';
            //   snackbar.navigation = () => {
            //     this.showToaster('Navigation not handled', TosterMsgType.ERROR);
            //     this.route('home');
            //   };
            //   break;

          }
          break;

        case lsm.isWaitingForSanction:
          snackbar.message = 'Please wait while we process your application.';
          snackbar.isRepeat = true;
          snackbar.navigation = this.showWaitingScreen.bind(this, ConstantData.waitingScreenStatus.waitingScreen2);
          break;
        case lsm.isKfsNotComplete:
          snackbar.message = 'Accept Key Fact statement';
          snackbar.navigation = this.route.bind(this, 'keyFactStatement');
          break;
        case lsm.isAfNotComplete:
          snackbar.message = 'Sign your application letter.';
          snackbar.navigation = () => {
            this.confirmApplicationForm().then(() => this.getProducts());
          };
          break;

        case lsm.eSigned === false:
          snackbar.message = 'Sign your application letter sent via email.';
          snackbar.navigation = this.route.bind(this, 'applicationLetter');
          break;

        case lsm.isPfNotComplete:
          snackbar.message = 'Pay the processing fee.';
          snackbar.navigation = this.route.bind(this, 'processingFee');
          break;

        case !lsm.overallConfirmation:
          snackbar.message = 'Register for e-NACH.';
          snackbar.navigation = () => {
            this.confirmLoan();
          };
          break;
        case !lsm.nachRegistrationConfirmation && lsm.isPNACHNotComplete:
          snackbar.message = 'Confirm NACH details.';
          snackbar.navigation = this.route.bind(this, 'nachMandate');
          break;

        default:
          snackbar.message = 'Please wait while we work on disbursing your loan';
          snackbar.isRepeat = true;
          snackbar.navigation = () => {
            this.route('home');
            this.show('', '', this.route.bind('home'), false, false, '', '', '', '', '', true);
          };
          break;

      }


    }
    if (snackbar && !isSnackBar) {
      snackbar.navigation();
    }
    else if (!isSnackBar) {
      this.route(sessionStorage.getItem('route'));
    }
    return snackbar;
  }
  navigationForMoratorium(lsm: any, snackbar: any) {
    const moratorium = lsm.hasMoratorium
    switch (true) {
      case lsm.aadhaarConfirmation == false:
        {
          snackbar.message = "Add your Aadhaar details";
          snackbar.navigation = this.route.bind(this, 'aadharDetails');
          break;
        }
      case lsm.isMaSelfiNotComplete || lsm.notSubmitedForReview:
        {
          snackbar.message = "Upload your selfie";
          snackbar.navigation = this.route.bind(this, 'selfie');
          break;
        }
      default:
        snackbar.message = `not handled yet`;
        snackbar.navigation = this.route.bind(this, 'home');
        break;
    }
  }
  bankScreenLogic(snackbar: SnackbarData, lsm: any, isCoApp: boolean = false) {
    const loanApplicantDetails = lsm.loanApplicantDetails?.find((e: any) => e.mainApplicant == !isCoApp);
    const text = isCoApp ? 'Co-Applicant\'s' : 'your';
    switch (true) {
      case !lsm.submittedForLevel1 || lsm.loanEligibilityStatusV2 === LoanStatusConstant.processing:
        snackbar.message = 'Please wait while we process your application.';
        snackbar.isRepeat = true;
        snackbar.navigation = this.route.bind(this, 'eligibility');
        break;
      case (lsm.loanEligibilityLevel === 'level2' ? loanApplicantDetails.bankConfirmation == true : !!lsm.loanCommercialDetails.length):
        switch (true) {
          case lsm.partialApproved || lsm.partialApprovedAmount:
            snackbar.message = lsm.hasMoratorium ? 'Your loan terms have been updated' : 'Check your new loan terms';
            snackbar.navigation = this.route.bind(this, 'eligibility');
            break;
          default:
            snackbar.message = 'Confirm your loan amount.';
            snackbar.navigation = this.route.bind(this, 'eligibility');
            break;

        }

        break;

      default:
        this.bankDetailsSnackbar(snackbar, lsm, isCoApp);
        break;


    }
  }

  confirmLoan() {
    this.handleRequests('put', this.getUrl('loan_confirm'), {
      'loanId': this.loanDetails.loanId
    }).then((res: any) => {
      this.getProducts().then(() => {
        this.navigationHandler();
      })
    })
  }

  bankDetailsSnackbar(snackbar: SnackbarData, lsm: any, isCoApp: boolean = false) {
    const loanApplicantDetails = lsm.loanApplicantDetails!.find((e: any) => e.mainApplicant == !isCoApp);
    const text = isCoApp ? 'Co-Applicant\'s' : 'your';
    switch (true) {
      case loanApplicantDetails.loanBankConnectAccountsInfo != null && !!loanApplicantDetails.loanBankConnectAccountsInfo.length: {
        snackbar.message = `Confirm ${text} bank details`;
        snackbar.navigation = this.route.bind(this, 'bankDetails');
        break;
      }
      default:
        snackbar.message = `Add ${text} bank details`;
        snackbar.navigation = this.route.bind(this, 'bankDetails');
        break;
    }
  }

  /**
   * Function to handle the navigations of the School fee based on the current loan details
   * @param lsm - current loan detail
   */
  navigationForSF(lsm: any, snackbar: SnackbarData) {

    switch (true) {
      case lsm.isInRejectedState:
        switch (true) {
          case lsm.pullbackAllowed:
            switch (true) {
              case lsm.applicantList.length == 1:
                snackbar.message = 'Add a co-applicant';
                snackbar.navigation = this.showToaster.bind(this, 'eligibility');
                break;

              case lsm.applicantList.length > 1 && lsm.applicantList.length < 3:
                snackbar.message = 'Add a co-applicant';
                snackbar.navigation = this.showToaster.bind(this, 'eligibility');
                break;

              default:
                snackbar.message = 'Replace co-applicant';
                snackbar.navigation = this.route.bind(this, 'eligibility');
                break;
            }
            break;

          default:
            snackbar.message = 'Please start over';
            snackbar.navigation = this.route.bind(this, 'rejectionScreen');
            break;
        }
        break;

      case lsm.institutionInfo != null && lsm.institutionInfo!.candidateName == null:
        snackbar.message = 'Add student details';
        snackbar.navigation = this.route.bind(this, 'studentDetails');
        break;

      case lsm.institutionInfo != null && lsm.institutionInfo!.tenorMonths == null:
        snackbar.message = 'Add your loan details';
        snackbar.navigation = this.route.bind(this, 'loanDetails');
        break;

      case lsm.notSubmitedForReview:
        // switch(true){
        switch (true) {
          //add pan detail
          case lsm.isMaPanNotComplete:
            snackbar.message = 'Add basic details';
            snackbar.navigation = this.route.bind(this, 'basicDetails');
            // switch(true){

            //   case lsm.isPanInfoNotSaved:
            //     snackbar.message = 'Add pan details';
            //     snackbar.navigation = this.route.bind(this, 'basicDetails');
            //     break;

            //   case !lsm.isPanInfoNotSaved:
            //     snackbar.message = 'Add basic details';
            //       snackbar.navigation = this.route.bind(this, 'basicDetails');
            //       break;
            // }
            break;

          case lsm.hasCoapplicant:
            this.navigationForcoApplicant(lsm, snackbar);
            break;

          case lsm.empDetailsNotAdded:
            snackbar.message = 'Add Employement details';
            snackbar.navigation = this.route.bind(this, 'employmentDetails');
            break;

          case lsm.amount == null && !lsm.isStudentMajorandHclorCap:
            this.bankScreenLogic(snackbar, lsm);
            break;

          case lsm.isInsuranceAdditionNotCompleted && !lsm.isStudentMajorandHclorCap:
            snackbar.message = 'Add Insurance details';
            snackbar.navigation = this.route.bind(this, 'insurance');
            break;

          case ((lsm.isStudentMainApplicant && (lsm.isEmployed || lsm.isSelfEmployed)) ||
            !lsm.isStudentMainApplicant) &&
            lsm.isMaBankNotComplete && !lsm.isStudentMajorandHclorCap:
            this.bankDetailsSnackbar(snackbar, lsm);
            break;

          case lsm.isMaAadharNotComplete:
            snackbar.message = 'Add your Aadhaar details';
            snackbar.navigation = this.route.bind(this, 'aadharDetails');
            break;
          case lsm.isMaSelfiNotComplete || lsm.notSubmitedForReview:
            snackbar.message = 'Upload your selfie';
            snackbar.navigation = this.route.bind(this, 'selfie');
            break;

          //////this default scenario will never come///////

          // default:
          //   snackbar.message = 'Navigation not handled';
          //   snackbar.navigation = () => {
          //     this.showToaster('Navigation not handled', TosterMsgType.ERROR);
          //     this.route('home');
          //   };
          //   break;

        }
        break;

      case lsm.isWaitingForSanction:
        snackbar.message = 'Please wait while we process your application.';
        snackbar.isRepeat = true;
        snackbar.navigation = this.showWaitingScreen.bind(this, ConstantData.waitingScreenStatus.waitingScreen2);
        break;
      case lsm.isKfsNotComplete:
        snackbar.message = 'Accept Key Fact statement';
        snackbar.navigation = this.route.bind(this, 'keyFactStatement');
        break;
      case lsm.isAfNotComplete:
        snackbar.message = 'Sign your application letter.';
        snackbar.navigation = () => {
          this.confirmApplicationForm().then(() => this.getProducts());
        };
        break;

      case lsm.eSigned === false:
        snackbar.message = 'Sign your application letter sent via email.';
        snackbar.navigation = this.route.bind(this, 'applicationLetter');
        break;

      case lsm.isPfNotComplete:
        snackbar.message = 'Pay the processing fee.';
        snackbar.navigation = this.route.bind(this, 'processingFee');
        break;

      case !lsm.overallConfirmation:
        snackbar.message = 'Register for e-NACH.';
        snackbar.navigation = () => {
          this.confirmLoan();
        };
        break;
      case !lsm.nachRegistrationConfirmation && lsm.isPNACHNotComplete:
        snackbar.message = 'Confirm NACH details.';
        snackbar.navigation = this.route.bind(this, 'nachMandate');
        break;

      default:
        snackbar.message = 'Please wait while we work on disbursing your loan';
        snackbar.isRepeat = true;
        snackbar.navigation = () => {
          this.route('home');
          this.show('', '', this.route.bind('home'), false, false, '', '', '', '', '', true);
        };
        break;




    }

  }



  navigationForcoApplicant(lsm: any, snackbar: SnackbarData) {
    const loanApplicantDetails = lsm.loanApplicantDetails[1];

    switch (true) {
      case loanApplicantDetails.panConfirmation == false:
        // snackbar.message = 'Add Co-Applicant\'s PAN details';
        // snackbar.navigation = this.route.bind(this, 'pan');
        switch (true) {

          case loanApplicantDetails.panInfo == null:
            snackbar.message = 'Add Co-Applicant\'s pan details';
            snackbar.navigation = this.route.bind(this, 'basicDetails');
            break;

          case loanApplicantDetails.panInfo != null:
            snackbar.message = 'Add Co-Applicant\'s basic details';
            snackbar.navigation = this.route.bind(this, 'basicDetails');
            break;
        }
        break;

      case loanApplicantDetails.empInfo?.workExperienceId == null:
        {
          snackbar.message = 'Add Co-Applicant\'s employment details';
          snackbar.navigation = this.route.bind(this, 'employmentDetails');
          break;
        }
      case lsm.amount == null:
        {
          this.bankScreenLogic(snackbar, lsm, true);
          break;
        }
      case lsm.isInsuranceAdditionNotCompleted:
        snackbar.message = 'Add Insurance details';
        snackbar.navigation = this.route.bind(this, 'insurance');
        break;

      case loanApplicantDetails.bankPending:
        this.bankDetailsSnackbar(snackbar, lsm, true);
        break;
      case (loanApplicantDetails.aadhaarConfirmation == false ||
        (lsm.loanApplicantDetails[1].aadhaarConfirmation == false)):
        {
          snackbar.message = "Add your aadhaar details";
          snackbar.navigation = this.route.bind(this, 'aadharDetails');
          break;
        }
      case lsm.isMaSelfiNotComplete || loanApplicantDetails.selfiNotComplete || lsm.notSubmitedForReview:
        {
          snackbar.message = "Add your Selfie";
          snackbar.navigation = this.route.bind(this, 'selfie');
          break;
        }
      default:
        snackbar.message = `not handled yet 1`;
        snackbar.navigation = this.route.bind(this, 'home');
        break;
    }



  }


  /**
   * Method to calculate the emi per month
   * @param rate - float number - loan intrest rate
   * @param time - number - number of months
   * @param prinicpal - float number - loan amount
   * @returns - emi amount per month
   */
  monthlyEMI(rate: number, time: number, prinicpal: number) {
    const p = prinicpal;
    const t = time;
    let r;
    if (rate == 0) {
      r = 0;
    } else {
      r = rate / 12 / 100;
    }
    const emi = r == 0 ? p / time : p * r * Math.pow(1 + r, t) / (Math.pow(1 + r, t) - 1);
    return Math.round(emi);
  }

  /**
   * method to show the dialog box
   * @param title - string - Title of the dialogb ox
   * @param callBack - callback function - it will call when user click on the yes/continue
   * @param onClose - callback function - it will call when user click on close icon or no button
   * @param showNoBtn - boolean - to show/hide  no button
   * @param showYesBtn - boolean -  to show/hide  yes button
   * @param text1 - string - to show the text message below the dialog box title
   * @param text2 - string - to show the highlighted text
   * @param noBtnTxt - string - text that you want to show in no/cancel button
   * @param yesBtnTxt - string - text that you want to show in yes/continue button
   */
  show(title: string, callBack: any, onClose: any, showNoBtn: boolean, showYesBtn: boolean, text1?: string, text2?: string, text3?: string, noBtnTxt?: string, yesBtnTxt?: string, isDisbursed: boolean = false, isValidating: boolean = false, icon?: string) {
    this.dialogBox.show(title, callBack, onClose, showNoBtn, showYesBtn, text1, text2, text3, noBtnTxt, yesBtnTxt, isDisbursed, isValidating, icon);
  }

  hide() {
    return this.dialogBox.hide();
  }


  /**
   * Method the discard the loan
   * @param callback - Function - Function that will get's call when loan discard's successfully
   */
  discardLoan(callback: any) {
    this.handleRequests('put', this.getUrl('loan_discard', [this.loanDetails.loanId])).then(() => {
      this.clearCache();
      this.getUserInfo(undefined, undefined, callback);
    })
  }


  /**
   * Date formatter mrhtod which will format's the date to given format string
   * @param date - string - dd/mm/yyyy
   * @param format - String - Date format string like yyyy-MM-dd, dd-mm-yyyy, etc.
   * @returns formatted date
   */
  formatDate(date: string, format: string) {
    let dateArray: any = [];
    if (date.includes('/')) {
      dateArray = date.split('/');

    } else if (date.includes('-')) {
      dateArray = date.split('-');
    }
    const map: any = {
      'yyyy': date.includes('-') ? dateArray[0] : dateArray[2],
      'MM': dateArray[1],
      'dd': date.includes('-') ? dateArray[2] : dateArray[0],
      // 'HH': date.getHours().toString().padStart(2, '0'),
      // 'mm': date.getMinutes().toString().padStart(2, '0'),
      // 'ss': date.getSeconds().toString().padStart(2, '0'),
    };

    return format.replace(/yyyy|MM|dd|HH|mm|ss/g, (match: any) => map[match]);
  }



  getIsAdult(birthDateString: string, age: number = ConstantData.adultAge): boolean {
    const datePattern: string = 'yyyy-MM-dd';
    const today: Date = new Date();
    const birthDate: Date = new Date(Date.parse(this.formatDate(birthDateString, datePattern) || ''));

    // Calculate adult date
    const adultDate: Date = new Date(
      birthDate.getFullYear() + age,
      birthDate.getMonth(),
      birthDate.getDate()
    );

    return adultDate <= today;
  }


  getsanckbarStatus() {
    return this.navigationHandler(true);
  }

  getTenureDetails(): TenureDetails[] {
    return this.dataservice.getTenureDetails();
  }

  updateCommercials(selectedTenure: TenureDetails, isWithMoratoriumSelected: boolean = false) {
    return this.fetchservice.updateCommercials(this.loanDetails, selectedTenure, isWithMoratoriumSelected);
  }

  showWaitingScreen(status?: string) {

    this.dialogBox.showwaitingDialog(status);
  }
  hideWaitingScreen(isHome: boolean = true) {
    this.dialogBox.hidewaitingDialog(isHome);
  }


  submitLoan() {

    this.fetchservice.submitLoan(this.loanDetails, this.getCurrentApplicant, this.waitingFunctionLoop.bind(this));
  }



  waitingFunctionLoop() {

    this.getProducts(undefined, false).then(() => {
      const loan = this.loanDetails;

      if (loan.isWaitingForSanction) {
        setTimeout(() => {
          this.waitingFunctionLoop();
        }, 2000);
      } else {
        const snackbar = this.navigationHandler(true);
        if (snackbar && snackbar.navigation) {
          snackbar.navigation();
        }
      }

    })


  }


  confirmApplicationForm() {
    return this.handleRequests('put', this.getUrl('loan_confirm_applicationForm'), { "loanId": this.loanDetails.loanId });
  }

  updateESigned(showLoader: boolean = true) {
    return this.fetchservice.updateESigned(this.loanDetails, showLoader);
  }


  notifyPayment(output: any) {
    let requestData = {
      "loanId": this.loanDetails.loanId,
      "output": output
    }
    this.handleRequests('put', this.getUrl('payment_notify', []), requestData).then((res: any) => {
      localStorage.removeItem('paymentOutput');
      this.getProducts().then(() => {
        if (this.loanDetails.isPfNotComplete) {
          this.showToaster('Payment Failed', TosterMsgType.ERROR);
        }
        this.navigationHandler()
      })
    });
  }

  openInstitute(category: string, lat: any, lng: any) {
    if (category == 'EL_SF') {
      let params = { "schoolName": "", "city": '', "state": '', lat, lng };
      const base64Str = btoa(JSON.stringify(params));
      this.handleRequests('get', this.getUrl('school_filter', [base64Str])).then(res => {
        if (res.content.nearBySchool) {
          this.setCache("instituteList", res.content.nearBySchool);
        }
        else {
          this.setCache("instituteList", res.content.allSchool);
        }
        this.setCache('selectedCatogory', category)
      });
      this.handleRequests('get', this.getUrl('constants_selected_city')).then(res => {
        this.setCache('cityApiRes', res);
        this.route('institutes');
        this.updatedDataInstitue.next(true);
      });
    }
    else {
      this.handleRequests('get', this.getUrl('courses_v2_all', ['', category, 0, 6])).then(res => {

        this.setCache("instituteList", res);
        this.setCache('selectedCatogory', category)
        this.setCache('cityApiRes', null);
        this.route('institutes');
        this.updatedDataInstitue.next(true);
      });

    }

  }

  loadProduct(product: any, pproduct: any, lat: any, lng: any) {

    const loandata = this.loanDetails;

    const productCategory = loandata && loandata.productCategory === product.id;


    if (!loandata) {
      this.setCache('productCat', product);
      this.setCache('product', pproduct);
      this.openInstitute(product.id, lat, lng);
    }
    else {
      if (!productCategory) {
        this.route('home');
        this.clearInstitudeData();
        if (loandata.notSubmitedForReview) {
          this.show(
            ConstantData.discardLoanTitle,
            this.discardLoan.bind(this, this.loadProduct.bind(this, product, pproduct)),
            () => { },
            false,
            true,
            ConstantData.discardLoanText1,
            ConstantData.discardLoanText2,
            '',
            '',
            ConstantData.discardLoanBtnText
          );
        } else {
          this.showToaster('You have not finished the previous loan process', TosterMsgType.WARNING)
        }


      } else {

        this.navigationHandler();
      }

    }

  }

  searchAllCoursesInstitudes(name: string, pageNo: number, pageSize: number, isLoading: boolean) {
    return this.fetchservice.searchAllCoursesInstitudes(name, pageNo, pageSize, isLoading)
  }
  openCourses(institute: any) {
    const loandata = this.loanDetails;
    const category: string = institute.categoryId;
    this.setCache("instituteList", null);
    this.setCache('currentInstituteCourses', null);
    this.setCache('currentInstitute', null);
    this.setCache('selectedCatogory', category);
    const productCategory = loandata && loandata.productCategory === category;

    if (!loandata) {

      if (category == 'EL_SF') {
        let params = { "schoolName": institute.name, "city": '', "state": '', "lat": this.getCache('lat'), "lng": this.getCache('lng') };
        const base64Str = btoa(JSON.stringify(params));
        this.handleRequests('get', this.getUrl('school_filter', [base64Str])).then(res => {
          if (res.content.nearBySchool) {
            this.setCache("instituteList", res.content.nearBySchool);
          }
          else {
            this.setCache("instituteList", res.content.allSchool);
          }
        });
        this.handleRequests('get', this.getUrl('constants_selected_city')).then(res => {
          this.setCache('cityApiRes', res);
          this.route('institutes');
          this.updatedDataInstitue.next(true);
        });
      } else {
        this.handleRequests('get', this.getUrl('courses_courses', ['', institute.id, 0, 6])).then(res => {
          this.setCache('currentInstituteCourses', res);
          this.setCache('currentInstitute', institute);
          localStorage.setItem('currentInstituteCourses', JSON.stringify(res));
          localStorage.setItem('currentInstitute', JSON.stringify(institute));
          this.route('courses');
        });
      }
    }
    else {
      if (!productCategory) {
        if (loandata.notSubmitedForReview) {
          this.show(
            ConstantData.discardLoanTitle,
            this.discardLoan.bind(this, this.openCourses.bind(this, institute)),
            () => { },
            false,
            true,
            ConstantData.discardLoanText1,
            ConstantData.discardLoanText2,
            '',
            '',
            ConstantData.discardLoanBtnText
          );
        } else {
          this.showToaster('You have not finished the previous loan process', TosterMsgType.WARNING)
        }


      } else {

        this.navigationHandler();
      }

    }


  }

  selectCourse(course: any) {
    if (this.isUserLoggedIn) {
      this.openCourses(course);
    } else {
      sessionStorage.setItem('course', JSON.stringify(course));
      this.route('login');
    }
  }

  formatNumber(number: number): string {
    if (isNaN(number)) {
      return "Invalid input";
    }

    // Define the conversion factors
    const crore = 10000000;
    const lakh = 100000;

    // Check if the number is greater than or equal to 1 crore
    if (number >= crore) {
      return (number / crore).toFixed(0) + " cr";
    }

    // Check if the number is greater than or equal to 1 lakh
    if (number >= lakh) {
      return (number / lakh).toFixed(0) + " lakh";
    }

    // If the number is less than 1 lakh, just return the number
    return number?.toString();
  }
  cameraPermissionTimeOut: any;
  askForCameraPermission() {
    navigator.mediaDevices.getUserMedia({ audio: false, video: this.isMobile ? { facingMode: this.getCurrentApplicant.mainApplicant ? 'user' : 'environment' } : true }).then((data) => {
      data.getTracks().forEach((track) => {
        track.stop();
      });
      clearTimeout(this.cameraPermissionTimeOut);
      this.permissionsService.hide();
    }).catch((err: any) => {
      this.permissionsService.show('Camera access Denied', 'Please go to your browser\'s settings and allow NorthernArc to access camera services.');
      clearTimeout(this.cameraPermissionTimeOut);
      this.cameraPermissionTimeOut = setTimeout(() => {
        this.askForCameraPermission();
      }, 100);
    });
  }

  clearInstitudeData() {
    localStorage.removeItem('product');
    localStorage.removeItem('cat');
    localStorage.removeItem('lat');
    localStorage.removeItem('lng');
    sessionStorage.removeItem('course');
    localStorage.removeItem('currentInstituteCourses');
    this.setCache("instituteList", null);
  }


  getPincode(lat: number, lng: number) {
    return this.api.getPincode(lat, lng);
  }

  cleverTapEventCall(eventName: any, eventParameters: any = {}) {
    const userId = this.userId;
    if (userId) {
      if (eventName !== 'onUserLogin') {
        this.handleRequests('post', this.getUrl('clevertap_event', [userId, eventName]), eventParameters, undefined, undefined, undefined, false, false).then((res) => {
        }).catch((err) => { console.log(err); });
      } else {
        this.handleRequests('post', this.getUrl('clevertap_profile', [userId]), eventParameters, undefined, undefined, undefined, false, false).then((res) => {
        }).catch((err) => { console.log(err); });
      }
    }
  }
}
